import React, { useState, useEffect } from 'react';
import { callingAPI } from '../config'
import eye from "../images/icons/eye.png"
import Mobile from '../images/icons/mobilebg.png';
import Tooltip from '@mui/material/Tooltip';

function SmsEmail() {
	const [communicationcount, setCommunicationCount] = useState()
	const [communication, setCommunication] = useState([]);
	const [savesms, setSaveSms] = useState()
	const [saveemail, setSaveEmail] = useState()
	const SmsCheckboxOnChange = (SmsEmailId, hasSms, smsEmailMessageTypeId) => {
		const SmsData = {
			"userId": window.sessionStorage.getItem("userId"),
			"pmMessageContentDetailsId": SmsEmailId,
			"smsEmailMessageTypeId": smsEmailMessageTypeId,
			"pmMessageContentDetailsIsSms": hasSms,
		}
		callingAPI('smsAndEmail/saveSmsDetails', SmsData
		).then((response) => {

			if (response.data.success === "1") {
				setSaveSms((response.data.successMessage))
				smsEmailCommunicationListing()
			}
		}
		)
			.catch((err) => console.log(err, "err"))
	};
	const EmailCheckboxOnChange = (SmsEmailId, hasEmail, smsEmailMessageTypeId) => {
		const EmailData = {
			"userId": window.sessionStorage.getItem("userId"),
			"pmMessageContentDetailsId": SmsEmailId,
			"smsEmailMessageTypeId": smsEmailMessageTypeId,
			"pmMessageContentDetailsIsMail": hasEmail,
		}
		callingAPI('smsAndEmail/saveEmailDetails', EmailData
		).then((response) => {

			if (response.data.success === "1") {
				setSaveEmail(response.data.successMessage)
				smsEmailCommunicationListing()
			}
		}
		)
			.catch((err) => console.log(err, "err"))
	};


	const smsEmailCommunicationListing = () => {

		const PostData = {
			"userId": window.sessionStorage.getItem("userId"),
			offset: "0",
			max: 100,
			"groupHospitalID": ""
		}
		callingAPI('smsAndEmail/communicationForm', PostData

		).then((response) => {
			if (response.data.success === "1") {
				setCommunication(response.data.result.smsEmailCommunicationData)
				setCommunicationCount(response.data.result.smsCount)
			}
		}
		)
			.catch((err) => console.log(err, "err"))
	}
	useEffect(() => {
		smsEmailCommunicationListing()
	}, []);

	const SavesmswhenCheckBoxchecked = (e, id, smsCheckboxOnChange) => {
		const checked = e.target.checked;
		SmsCheckboxOnChange(id, checked, smsCheckboxOnChange)
	};
	const SaveemailwhenCheckBoxchecked = (e, id, emailCheckboxOnChange) => {
		const checked = e.target.checked;
		EmailCheckboxOnChange(id, checked, emailCheckboxOnChange)
	};
	return (
		<div className="dashboardCover">
			<div className="dashboardTitle">
				SMS & Email Communication Settings
				<div class="smsNotify">Remaining Transactional SMS count : {communicationcount}</div>
				<div class="smsNotifyError" style={{ display: 'none' }}>
					You have not subscribed for SMS plan, Please contact our customer support.{' '}
				</div>
			</div>


			<div className="dashboardContent">
				<div className="reportWrap">
					<div className="dashboardtable">
						<table>
							<thead>
								<tr>
									<th>Name</th>
									<th>SMS/Email To</th>
									<th>SMS</th>
									<th>Email</th>
									<th>SMS/Email Content</th>
								</tr>
							</thead>
							<tbody id="smsEmailMessageTypeName">
								{communication.map((item, i) => (
									<tr>
										<td>{item.smsEmailMessageTypeName}</td>
										<td>{item.smsEmailTo}</td>
										<td>
											<span class="checkSection">

												<input type="checkbox" id={"checkbox1" + i} defaultChecked={item.pmMessageContentDetailsIsSms === 1 ? true : false}
													onChange={(e) => { SavesmswhenCheckBoxchecked(e, item.pmMessageContentDetailsId, item.smsEmailMessageTypeId) }} />
												<label for={"checkbox1" + i}></label>


											</span>SMS
										</td>
										<td>
											<span class="checkSection"  >

												<input type="checkbox" id={"checkbox2" + i} defaultChecked={item.pmMessageContentDetailsIsMail === 1 ? true : false}
													onChange={(e) => { SaveemailwhenCheckBoxchecked(e, item.pmMessageContentDetailsId, item.smsEmailMessageTypeId) }} />
												<label for={"checkbox2" + i}></label>
											</span>Email
										</td>

										<td>
											<span className="chartImg">
												<Tooltip
													title={
														<>
															<div style={{ fontWeight: 'bold', marginBottom: '4px' }}>SMS Content</div>
															<div style={{ marginBottom: '8px' }}>{item.smsEmailMessageTypeSmsText || 'N/A'}</div>
															<div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Email Content</div>
															<div>{item.smsEmailMessageTypeMessageText || 'N/A'}</div>
														</>
													} arrow
													componentsProps={{
														tooltip: {
															sx: {
																backgroundColor: 'white',
																color: 'black',
																boxShadow: 3,
																fontSize: '0.875rem',
															},
														},
													}}
												>
													<a href="#sms_viewmore">
														<img src={eye} alt="View Details" />
													</a>
												</Tooltip>
											</span>
										</td>
									</tr>
								))}
							</tbody>
						</table>

					</div>
				</div>
			</div>
		</div>
	);
}
export default SmsEmail
